<template>
    <div class="context common_add_view">
        <div class="header">
            <div class="search">
                <el-page-header @back="back" :content="viewTitle">
                </el-page-header>
            </div>
        </div>
        <div class="main_box">
            <el-form :model="form" :rules="rules" ref="form" label-width="150px">
                <el-form-item label="活动名称：" prop="activity_name">
                    <el-input class="width_220" v-model="form.activity_name"></el-input>
                </el-form-item>
                <el-form-item label="活动类型：" prop="etype">
                    <el-select class="width_220"
                               @change="changeType"
                               v-model="form.etype">
                        <el-option v-for="(item,index) in typeList"
                                   :label="item.name"
                                   :value="item.value"
                                   :key="index"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="上传图片：" prop="img_path">
                    <el-image v-if="form.real_img_path"
                              :src="form.real_img_path"
                              style="width: 235px;
                              height: 100px;
                              border: 1px solid #ccc;
                              border-radius: 2px;"></el-image>
                    <ImgCutter v-on:cutDown="cutDown"
                               :sizeChange="false"
                               :moveAble="true"
                               :cutWidth="235"
                               :cutHeight="100"
                               :tool="false"
                               style="width: 110px">
                        <el-button style="margin-bottom: 20px" slot="open">选择图片</el-button>
                    </ImgCutter>
                </el-form-item>
                <el-form-item label="选择文章："
                              prop="paper_id"
                              v-if="form.etype === 'paper'">
                    <div class="form_table">
                        <el-card v-if="paper_video_data" shadow="never" class="card_item">
                            <div class="img_box">
                                <img :src="showImgUrl(paper_video_data)" alt="">
                            </div>
                            <div class="title">{{paper_video_data.title}}</div>
                            <div class="text">
                                {{paper_video_data.digest}}
                            </div>
                            <div class="flex_box date">
                                <div>{{paper_video_data.update_time}}</div>
                                <div>
                                    <el-popover
                                            placement="left"
                                            width="200"
                                            trigger="click">
                                        <div class="qrcode" style="height: 200px">
                                            <vue-qr :logoSrc="imageUrl"
                                                    :text="paper_video_data.url"
                                                    :size="200"></vue-qr>
                                        </div>
                                        <span slot="reference"
                                              style="cursor: pointer"
                                              class="iconfont icon-erweima"></span>
                                    </el-popover>
                                </div>
                            </div>
                            <div class="flex_box">
                                <div class="title_f">分类：</div>
                                <div class="text_f select">
                                    {{paper_video_data.cate}}
                                </div>
                            </div>
                            <div class="flex_box">
                                <div class="title_f">标签：</div>
                                <div class="text_f tags">
                                    <el-tag
                                            :key="tag"
                                            v-for="tag in paper_video_data.tag_list"
                                            size="small"
                                            class="tag_item"
                                            :disable-transitions="false">
                                        {{tag}}
                                    </el-tag>
                                </div>
                            </div>
                            <div class="flex_box bottom_flex">
                                <div class="title_f">积分：</div>
                                <div class="text_f input_num">
                                    <span>{{paper_video_data.num || '默认'}}</span>
                                </div>
                            </div>
                        </el-card>
                        <el-button @click="openDrow('选择文章')">选择文章</el-button>
                    </div>
                </el-form-item>
                <el-form-item label="选择视频："
                              prop="paper_id"
                              v-if="form.etype === 'video'">
                    <div class="form_table">
                        <el-card v-if="paper_video_data"
                                 shadow="never"
                                 class="card_item card_item_video">
                            <div class="title">{{paper_video_data.title}}</div>
                            <div class="flex_box date">
                                <div>{{paper_video_data.update_time}}</div>
                                <div>
                                    <el-popover placement="left" width="200" trigger="click">
                                        <div class="qrcode" style="height: 200px">
                                            <img :src="paper_video_data.url" alt="加载失败" srcset="" style="width:100%;height:100%;">
                                        </div>
                                        <span
                                                slot="reference"
                                                style="cursor: pointer"
                                                class="iconfont icon-erweima"
                                        ></span>
                                    </el-popover>
                                </div>
                            </div>
                            <div class="flex_box">
                                <div class="title_f">分类：</div>
                                <div class="text_f select">
                                    {{paper_video_data.cate}}
                                </div>
                            </div>
                            <div class="flex_box">
                                <div class="title_f">标签：</div>
                                <div class="text_f tags">
                                    <el-tag
                                            :key="tag"
                                            v-for="tag in paper_video_data.tags"
                                            size="small"
                                            class="tag_item"
                                            :disable-transitions="false">
                                        {{tag}}
                                    </el-tag>
                                </div>
                            </div>
                            <div class="flex_box bottom_flex">
                                <div class="title_f">积分：</div>
                                <div class="text_f input_num">
                                    <span>{{paper_video_data.num || '默认'}}</span>
                                </div>
                            </div>
                        </el-card>
                        <el-button @click="openDrow('选择视频')">选择视频</el-button>
                    </div>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submitNow">提交</el-button>
                </el-form-item>
            </el-form>


            <el-drawer
                    :title="draw_title"
                    :visible.sync="drawer_paper_video"
                    append-to-body
                    size="50%"
                    direction="rtl">
                <div class="draw_page">
                    <div class="search_box">
                        <el-form :model="searchForm" size="small">
                            <el-form-item label="标题">
                                <el-input v-model="searchForm.input"
                                          placeholder="请输入标题"
                                          @change="getTableData()"
                                          clearable
                                          class="width_200"></el-input>
                                <el-button style="margin-left: 15px"
                                           @click="getTableData()"
                                           type="primary">搜索
                                </el-button>
                            </el-form-item>
                            <el-form-item label="分类">
                                <div class="input_box">
                                    <div :class="searchForm.classification === ''?'actived_btn':''"
                                         @click="clearSearch('classification')"
                                         class="btn">不限
                                    </div>
                                    <div v-for="(item, index) in classOptions"
                                         :key="index"
                                         :class="searchForm.classification === item?'actived_btn':''"
                                         @click="changeCell(item.value, 'classification')"
                                         class="btn">
                                        {{item.value}}
                                    </div>
                                </div>
                            </el-form-item>
                            <el-form-item label="标签:">
                                <div class="check_box">
                                    <div class="all_check">
                                        <el-checkbox :indeterminate="isIndeterminate"
                                                     v-model="checkAll"
                                                     @change="handleCheckAllChange">
                                            全选
                                        </el-checkbox>
                                    </div>
                                    <div class="check_btn">
                                        <el-checkbox-group v-model="searchForm.tags"
                                                           @change="handleCheckedCitiesChange">
                                            <el-checkbox v-for="(item, index) in tagsOPtions"
                                                         :label="item"
                                                         :key="index">
                                                {{item}}
                                            </el-checkbox>
                                        </el-checkbox-group>
                                    </div>
                                </div>
                            </el-form-item>
                        </el-form>
                    </div>

                    <div class="table_box">
                        <el-card shadow="never"
                                 v-for="(item, index) in tableData"
                                 :key="index"
                                 class="card_item"
                                 :class="draw_title === '选择视频'?'card_item_video':''">
                            <div @dblclick="select_data(item)">
                                <div class="img_box" v-if="draw_title === '选择文章'">
                                    <img :src="showImgUrl(item)" alt="">
                                </div>
                                <div class="title">{{item.title}}</div>
                                <div class="text"
                                     v-if="draw_title === '选择文章'">
                                    {{item.digest}}
                                </div>
                                <div class="flex_box date">
                                    <div>{{item.update_time}}</div>
                                    <div v-if="draw_title === '选择文章'">
                                        <el-popover
                                                placement="left"
                                                width="200"
                                                trigger="click">
                                            <div class="qrcode" style="height: 200px">
                                                <vue-qr :logoSrc="imageUrl"
                                                        :text="item.url"
                                                        :size="200"></vue-qr>
                                            </div>
                                            <span slot="reference"
                                                  style="cursor: pointer"
                                                  class="iconfont icon-erweima"></span>
                                        </el-popover>
                                    </div>
                                    <div v-if="draw_title === '选择视频'">
                                        <el-popover placement="left" width="200" trigger="click">
                                            <div class="qrcode" style="height: 200px">
                                                <img :src="item.url" alt="加载失败" srcset="" style="width:100%;height:100%;">
                                            </div>
                                            <span
                                                    slot="reference"
                                                    style="cursor: pointer"
                                                    class="iconfont icon-erweima"
                                            ></span>
                                        </el-popover>
                                    </div>
                                </div>
                                <div class="flex_box">
                                    <div class="title_f">分类：</div>
                                    <div class="text_f select">
                                        {{item.cate}}
                                    </div>
                                </div>
                                <div class="flex_box">
                                    <div class="title_f">标签：</div>
                                    <div class="text_f tags"
                                         v-if="draw_title === '选择文章'">
                                        <el-tag
                                                :key="tag"
                                                v-for="tag in item.tag_list"
                                                size="small"
                                                class="tag_item"
                                                :disable-transitions="false">
                                            {{tag}}
                                        </el-tag>
                                    </div>
                                    <div class="text_f tags"
                                         v-if="draw_title === '选择视频'">
                                        <el-tag
                                                :key="tag"
                                                v-for="tag in item.tags"
                                                size="small"
                                                class="tag_item"
                                                :disable-transitions="false">
                                            {{tag}}
                                        </el-tag>
                                    </div>
                                </div>
                                <div class="flex_box bottom_flex">
                                    <div class="title_f">积分：</div>
                                    <div class="text_f input_num">
                                        <span>{{item.num || '默认'}}</span>
                                    </div>
                                </div>
                            </div>

                        </el-card>
                    </div>
                    <div class="bottom_page" id="bottom_page">
                        <page-view @getTableList="handleCurrentChange"
                                   :currentPage="currentPage"
                                   :pageSize="pageSize"
                                   :total="total"></page-view>
                    </div>
                </div>

            </el-drawer>
        </div>
    </div>
</template>

<script>
    import {mapState, mapMutations} from "vuex"
    import {clone} from "@/global/utils";
    import ImgCutter from 'vue-img-cutter'
    import {langRequest, getQrImageUrl} from "../../api/index";
    import vueQr from 'vue-qr'

    export default {
        name: "addView",
        components: {ImgCutter, vueQr},
        data() {
            return {
                viewTitle: '修改产品配置',

                form: {
                    activity_name: '',
                    etype: '',
                    img_path: '',
                    real_img_path: '',
                    paper_id: '',
                },
                paper_video_data: null,
                rules: {
                    activity_name: [{required: true, message: '请输入活动名称', target: 'blur'}],
                    etype: [{required: true, message: '请选择活动类型', target: 'blur'}],
                    img_path: [{required: true, message: '请上传图片', target: 'blur'}],
                    paper_id: [{required: true, message: '请选择文章(或视频)', type: 'number', target: 'blur'}],
                },

                typeList: [
                    {name: '视频', value: 'video'},
                    {name: '文章', value: 'paper'},
                ],

                draw_title: '选择文章',
                drawer_paper_video: false,
                searchForm: {
                    input: '',
                    classification: '',
                    tags: []
                },
                tag_list: [],
                tag_video_list: [],
                isIndeterminate: false,
                checkAll: false,

                tableData: [],
                imageUrl: '',

                total: 0,
                currentPage: 1,
                pageSize: 10,
            }
        },
        computed: {
            ...mapState('manageData', {
                active_config_data: 'active_config_data'
            }),
            ...mapState('comInformationData', [
                'classifyList',
                'videoClassifyList'
            ]),

            classOptions() {
                if(this.draw_title === '选择文章') {
                    return this.classifyList
                } else  {
                    return this.videoClassifyList
                }
            },
            tagsOPtions() {
                if(this.draw_title === '选择文章') {
                    return this.tag_list
                } else  {
                    return this.tag_video_list
                }
            },
        },
        mounted() {
            console.log(this.active_config_data, '20');
            if (this.active_config_data) {
                // this.form = clone(this.active_config_data)
                this.viewTitle = '修改活动';
                this.getForm(this.active_config_data.activity_id)
            } else {
                this.viewTitle = '新增活动';
                this.form = {
                    activity_name: '',
                    etype: '',
                    img_path: '',
                    paper_id: '',
                }
            }

            this.getTagList();
            this.getVideoTagList()
        },
        methods: {
            getForm(id) {
                this.httpGet(`/activity_manage/${id}`).then(res => {
                    this.form = res.data;
                    this.paper_video_data = res.data.paper_data
                })
            },
            cutDown(file) {
                console.log(file, '90');
                this.form.img_path = file.dataURL;
                this.form.real_img_path = file.dataURL;
                this.$forceUpdate()
            },

            getTagList() {
                this.httpGet('/paper/tag').then(res => {
                    this.tag_list = res.data;
                })
            },
            getVideoTagList() {
                this.httpGet("/video/tag").then((res) => {
                    this.tag_video_list = res.data;
                });
            },

            showImgUrl(item) {
                return item.thumb_file_path_url
            },
            changeType(e) {
                this.paper_video_data = null;
                this.form.paper_id = '';
            },
            openDrow(name) {
                this.draw_title = name;
                this.drawer_paper_video = true;
                this.getTableData()
            },

            clearSearch(val) {
                this.searchForm[val] = '';
                this.getTableData()
            },
            changeCell(item, val) {
                this.searchForm[val] = item;
                this.getTableData()
            },
            handleCheckAllChange(val) {
                this.searchForm.tags = val ? this.tag_list : [];
                this.isIndeterminate = false;
                this.getTableData()
            },
            handleCheckedCitiesChange(value) {
                let checkedCount = value.length;
                this.checkAll = checkedCount === this.tag_list.length;
                this.isIndeterminate = checkedCount > 0 && checkedCount < this.tag_list.length;
                this.getTableData()
            },


            handleCurrentChange(val) {
                this.getTableData(val)
            },
            getTableData(val = 1) {
                let params = {
                    page: val,
                    page_size: this.pageSize,
                    cates: this.searchForm.classification,
                    name: this.searchForm.input,
                    tags: this.searchForm.tags
                };
                let url = '/paper/list'; // /video/list
                if(this.draw_title === '选择视频') {
                    url = '/video/list';
                }
                this.httpPost(url, params).then(res => {
                    this.tableData = res.data.data_list;
                    this.total = res.data.total;

                    if(this.draw_title === '选择视频') {
                        this.tableData.map((v) => {
                            v.inputVisible = false;
                            v.inputValue = "";
                            v.url = getQrImageUrl(`/video/qrcode/${v.video_id}`);
                        });
                    }

                    this.$nextTick(() => {
                        this.currentPage = val;
                    })
                });
            },
            select_data(item) {
                console.log(item, '495');
                this.paper_video_data = item;
                if(this.draw_title === '选择文章') {
                    this.form.paper_id = item.paper_id
                } else if (this.draw_title === '选择视频') {
                    this.form.paper_id = item.video_id
                }
                this.drawer_paper_video = false;
            },

            back() {
                this.$emit('changeTopTab', 'tableView')
            },
            submitNow() {
                console.log(this.form, '512');
                this.$refs.form.validate(valid => {
                    if (valid) {
                        if (this.active_config_data) {
                            this.submitEdit()
                        } else {
                            this.submitAdd()
                        }
                    }
                })
            },
            submitAdd() {
                let params = {
                    ...this.form
                };
                this.httpPost('/activity_manage/add', params).then(res => {
                    this.$message.success('添加成功！');
                    this.back()
                })
            },
            submitEdit() {
                let params = {
                    ...this.form
                };
                this.httpPut(`/activity_manage/${params.activity_id}`, params).then(res => {
                    this.$message.success('修改成功！');
                    this.back()
                })
            },
        }
    }
</script>

<style scoped lang="scss">
    .context {
        width: 100%;
        height: 100%;

        .form_table {
            .card_item {
                width: 320px;
                min-height: 360px;
                position: relative;
                z-index: 1;
                margin: 0 5px 5px 0;
                line-height: 30px;
                .img_box {
                    width: 100%;
                    height: 180px;
                    border-bottom: 1px solid #ccc;
                    img {
                        width: 100%;
                        height: 100%;
                    }
                }
                .title {
                    padding: 0 10px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
                .text {
                    font-size: 0.875rem;
                    color: #8d8d8d;
                    padding: 0 10px;
                    height: 60px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                }
                .flex_box {
                    display: flex;
                    justify-content: space-between;
                    padding: 0 10px;
                    font-size: 0.875rem;
                    color: #8d8d8d;
                    .title_f {
                        flex: 0 0 60px;
                    }
                    .text_f {
                        flex: 1;
                    }
                    .select {

                    }
                    .tags {
                        display: flex;
                        flex-flow: wrap;
                        margin-bottom: 3px;
                        .tag_item {
                            margin: 2px 0 2px 5px;
                            border: none;
                            background: #EBEEF5;
                            color: #606266;

                        }
                    }
                    .input_num {
                    }
                }
                .bottom_flex {
                    margin-bottom: 5px;
                }
                .date {
                    font-size: 0.875rem;
                    color: #8d8d8d;
                    padding: 0 10px;
                }
            }
            .card_item_video {
                min-height: 120px;
            }
        }
    }

    .draw_page {
        width: 100%;
        height: 100%;
        display: flex;
        flex-flow: column;
        padding: 10px;
        box-sizing: border-box;

        .search_box {
            padding: 5px 10px;
            box-sizing: border-box;
            .radio_box {
                display: flex;
                line-height: 30px;
                .search_btn {
                    padding-left: 15px;
                }
            }
            .input_box {
                display: flex;
                flex-flow: wrap;
                .btn {
                    height: 25px;
                    line-height: 25px;
                    font-size: .875rem;
                    padding: 0 10px;
                    box-sizing: border-box;
                    margin: 7px 10px;
                    cursor: pointer;
                    color: #606266;
                }
                .actived_btn {
                    box-sizing: border-box;
                    border: 1px solid #38adff;
                    border-radius: 3px;
                }
            }
            .check_box {
                display: flex;
                .all_check {
                    flex: 0 0 80px;
                }
                .check_btn {
                    flex: 1;
                }
            }
        }
        .table_box {
            flex: 1;
            width: 100%;
            padding: 0 10px;
            overflow: hidden;
            overflow-y: auto;
            box-sizing: border-box;
            border-bottom: 1px solid #ddd;
            display: flex;
            flex-wrap: wrap;
            align-items: flex-start;
            .card_item {
                width: 320px;
                min-height: 360px;
                position: relative;
                z-index: 1;
                margin: 0 5px 5px 0;
                line-height: 30px;
                .img_box {
                    width: 100%;
                    height: 180px;
                    border-bottom: 1px solid #ccc;
                    img {
                        width: 100%;
                        height: 100%;
                    }
                }
                .title {
                    padding: 0 10px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
                .text {
                    font-size: 0.875rem;
                    color: #8d8d8d;
                    padding: 0 10px;
                    height: 60px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                }
                .flex_box {
                    display: flex;
                    justify-content: space-between;
                    padding: 0 10px;
                    font-size: 0.875rem;
                    color: #8d8d8d;
                    .title_f {
                        flex: 0 0 60px;
                    }
                    .text_f {
                        flex: 1;
                    }
                    .select {

                    }
                    .tags {
                        display: flex;
                        flex-flow: wrap;
                        margin-bottom: 3px;
                        .tag_item {
                            margin: 2px 0 2px 5px;
                            border: none;
                            background: #EBEEF5;
                            color: #606266;

                        }
                    }
                    .input_num {
                    }
                }
                .bottom_flex {
                    margin-bottom: 5px;
                }
                .date {
                    font-size: 0.875rem;
                    color: #8d8d8d;
                    padding: 0 10px;
                }
            }
            .card_item_video {
                min-height: 120px;
            }
        }
        .bottom_page {
            text-align: center;
        }
    }
</style>